export default {
  name: 'gmk-dolch'
};
